document.addEventListener('DOMContentLoaded', function () {
    function handleSlider() {
        let flickityElement = document.querySelector('.acc-kb-mojostack-redesign-07_evidencesGroup');

        if (window.innerWidth < 1440) {
            if (!flickityElement.classList.contains('flickity-enabled')) {
                let flickitySlider = new Flickity(flickityElement, {
                    draggable: true,
                    prevNextButtons: false,
                    cellAlign: "left",
                    autoPlay: false,
                    accessibility: false,
                    setGallerySize: true,
                    wrapAround: true
                });
            }
        } else {
            // If 1440 pixels or more, destroy the Flickity slider if it exists
            let flickityInstance = Flickity.data(flickityElement);
            if (flickityInstance) {
                flickityInstance.destroy();
            }
        }
    }

    handleSlider();

    window.addEventListener('resize', function () {
        handleSlider();
    });

    Fancybox.bind("[data-fancybox]", {
        // Your custom options
    });
});
